import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, Typography, TextField, DialogActions, Alert } from '@mui/material';
import { CloseSquare } from 'iconsax-react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { observer } from 'mobx-react';

const filter = createFilterOptions();

const TagsModal = observer(({ show, setShow, uiStore, card, setTags, tags }) => {
    const { error } = uiStore
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(tags);
    const [options, setOptions] = useState([]);

    const confirm = async () => {
        setLoading(true);
        const newTags = value.map(i => i.inputValue || i)
        await uiStore.updateConnectionTags(newTags, card._id);
        setTags(newTags);
        setShow(false);
        setLoading(false);
    };

    useEffect(() => {
        async function getTags() {
            await uiStore.getUserTags();
            setOptions(uiStore.tags)
        }

        setValue(tags);
        getTags();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, uiStore]);

    const filterOptions = (options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some((option) => inputValue === option);
        if (inputValue !== '' && !isExisting) {
            filtered.push({
                inputValue,
                label: `Add "${inputValue}"`,
            });
        }

        return filtered;
    }

    const getOptionLabel = (option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
            return option;
        }

        // Add "xxx" option created dynamically
        if (option.inputValue) {
            return option.inputValue;
        }

        // Regular option
        return option.label;
    };

    const handleAutocompleteChange = (e, value) => {
        setValue(value);
    };

    return (
        <Dialog
            open={show}
            onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            fullWidth
            maxWidth='xs'
        >
            <DialogTitle>
                Tags
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }

                <Typography>
                    Select the tags associated with this contact Or Create new tags
                </Typography>
                <Autocomplete
                    multiple
                    sx={{ mt: 3 }}
                    renderInput={(params) => <TextField label='Tags' {...params} />}
                    options={options || []}
                    value={value}
                    disabled={loading}
                    onChange={handleAutocompleteChange}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    filterOptions={filterOptions}
                    getOptionLabel={getOptionLabel}
                    filterSelectedOptions
                />

            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
});

export default TagsModal;